import { Select } from '@iqueue/ui-kit'
import { useCallback, useRef } from 'react'
import ProfilePresenter from '../../api/profilePresenter'
import { t } from '../../hooks/useTranslate'

export default function PickProfile({
  name = 'nodeId',
  current,
  value,
  ...props
}) {

  const cache = useRef()

  const render = useCallback((id) => {
    const item = cache.current.indexed[id]

    return {
      id: id,
      title: item?.name + ' ' + item?.surname,
      subtitle: item?.phoneNumber
    }
  }, [t, current])

  const fetchData = useCallback(() => {
    return ProfilePresenter.readIndexed(cache)
  }, [])

  return <Select
    name={ name }
    entries={ fetchData }
    render={ render }
    value={ value }
    { ...props }
  />
}
